<form [formGroup]="form" (ngSubmit)="onEnter()" class="time-entry-input">
  <div class="time-entry-input__title">create a new track</div>
  <div class="time-entry-input__container">
    <div class="time-entry-input__row row">

      <div class="time-entry-input__field time-entry-input__field--tags">
        <select-list #selectListProjects [optionList]="optionsFromProjects" [searchBar]="true" label="Projects" icon="folder" (selectedOptionChanged)="form.get('selectedProject')?.setValue($event)" />
      </div>

      <div class="time-entry-input__field time-entry-input__field--text">
        <mat-form-field appearance="fill" class="filters-form-field">
          <mat-label>What have you done?</mat-label>
          <mat-icon matPrefix class="me-1">edit</mat-icon>
          <input matInput formControlName="inputText" [matAutocomplete]="auto">
        </mat-form-field>
        <mat-autocomplete #auto="matAutocomplete">
          @for (option of (filteredOptions | async); track $index) {
          <mat-option [value]="option">{{option}}</mat-option>
          }
        </mat-autocomplete>
      </div>

      <div class="time-entry-input__field time-entry-input__field--tags">
        <select-list #selectListTags [optionList]="optionsFromTags" [multiple]="true" [searchBar]="true" label="Tags" icon="local_offer" (selectedOptionsChanged)="form.get('selectedTags')?.setValue($event)" />
      </div>

      <div class="time-entry-input__field time-entry-input__field--datetime">
        <input type="datetime-local" formControlName="startDate" class="time-entry-input__input" />

        <mat-icon class="time-entry-input__arrow">arrow_right</mat-icon>

        <input type="datetime-local" formControlName="endDate" class="time-entry-input__input" />
      </div>

      <div class="time-entry-input__field time-entry-input__field--submit">
        <button mat-mini-fab color="primary" [disabled]="!form.valid">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>
    </div>
  </div>
</form>
